import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import helper from './helper';
import { VisitGuides } from './models/guides';
const ENDPOINT = 'guides/';

export type GuideName = 
  'distributor_status' |
  'division' |
  'document_type' |
  'equipment_brand' |
  'equipment_condition' |
  'equipment_manufacturer' |
  'equipment_model/refrigerator' |
  'equipment_model/stand' |
  'equipment_status_erp' |
  'equipment_status_loc' |
  'equipment_type' |
  'federal_district' |
  'installation_type' |
  'outlet_acb_status' |
  'outlet_room_type' |
  'outlet_sales_representative' |
  'outlet_segment' |
  'outlet_status' |
  'outlet_sub_channel' |
  'outlet_type' |
  'outlet_update_request_status' |
  'payment_type' |
  'price_list' |
  'reason' |
  'route/list' | 
  'service_breakdown' |
  'service_department' |
  'service_status' |
  'stand_brand' |
  'transaction_status' |
  'transaction_type' |
  'user_group' |
  'user_position' |
  'user_role' |
  'sales_source' |
  'checked_statuses' |
  'stand_model';


export type GuidesRequestPayload = {
  name: GuideName;
} & Record<string, string>;

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  get: (payload: GuidesRequestPayload) =>
    instance.get<any, AxiosResponse<ApiResponse<EntityBase[]>>>(
      ENDPOINT +
        payload.name +
        '/' +
        helper.toQueryString({ ...payload, name: undefined }),
      config
    ),
  getVisitData: () =>
    instance.get<any, AxiosResponse<ApiResponse<VisitGuides>>>(
      ENDPOINT + 'visit_data/',
      config
    ),
  // checked status
  checkedStatusList: () =>
    instance.get<any, AxiosResponse<ApiResponse<EntityBase[]>>>(
      'guides_crud/checked_status/list/',
      {
        ...config,
        headers: {
          ...config.headers,
          'cache-force': 'true',
        }
      }
    ),
  checkedStatusCreate: (payload: { name: string; is_active: boolean }) =>
    instance.post<any, AxiosResponse<ApiResponse<EntityBase>>>(
      'guides_crud/checked_status/create/',
      payload,
      config
    ),
  checkedStatusUpdate: (payload: EntityBase & { is_active: boolean }) =>
    instance.put<any, AxiosResponse<ApiResponse<EntityBase>>>(
      'guides_crud/checked_status/update/',
      payload,
      config
    ),
  // department (guides_crud)
  departmentList: () =>
    instance.get<any, AxiosResponse<ApiResponse<Array<EntityBase & { is_active: boolean }>>>>(
      'guides_crud/department/list/',
      {
        ...config,
        headers: {
          ...config.headers,
          'cache-force': 'true',
        },
      }
    ),
  // shelves category (guides_crud)
  shelvesCategoryList: () =>
    instance.get<any, AxiosResponse<ApiResponse<Array<EntityBase & { is_active: boolean }>>>>(
      'guides_crud/shelves_category/list/',
      {
        ...config,
        headers: {
          ...config.headers,
          'cache-force': 'true',
        },
      }
    ),
  shelvesCategoryCreate: (payload: { name: string; is_active: boolean }) =>
    instance.post<any, AxiosResponse<ApiResponse<{ id: number }>>>(
      'guides_crud/shelves_category/create/',
      payload,
      config
    ),
  shelvesCategoryUpdate: (payload: { id: number; name: string; is_active: boolean }) =>
    instance.put<any, AxiosResponse<ApiResponse<{ id: number }>>>(
      'guides_crud/shelves_category/update/',
      payload,
      config
    ),
  // unit sku (guides_crud)
  unitSkuList: (is_active?: boolean) =>
    instance.get<any, AxiosResponse<ApiResponse<Array<EntityBase & { is_active: boolean }>>>>(
      'guides_crud/unit_sku/list/' + (is_active !== undefined ? `?is_active=${is_active}` : ''),
      {
        ...config,
        headers: {
          ...config.headers,
          'cache-force': 'true',
        },
      }
    ),
  unitSkuCreate: (payload: { name: string; is_active: boolean }) =>
    instance.post<any, AxiosResponse<ApiResponse<{ id: number }>>>(
      'guides_crud/unit_sku/create/',
      payload,
      config
    ),
  unitSkuUpdate: (payload: { id: number; name: string; is_active: boolean }) =>
    instance.put<any, AxiosResponse<ApiResponse<{ id: number }>>>(
      'guides_crud/unit_sku/update/',
      payload,
      config
    ),
  unitSkuDelete: (payload: { id: number; is_active: boolean }) =>
    instance.post<any, AxiosResponse<ApiResponse<{ id: number }>>>(
      'guides_crud/unit_sku/delete/',
      payload,
      config
    ),
});
